import React, { useState } from "react";
import './NotFoundPage.css'
import FourZeroFourIcon from '../Images/404 icon.svg'
import { useNavigate } from "react-router-dom";
const NotFoundPage = ()=>{
    const [timeleft,setTimeleft] = useState(5);
    const navigate = useNavigate()
    function repeatEverySecond() {
        console.log('This function runs every second.');
        setTimeleft(timeleft-1);
      }
      const intervalId = setInterval(repeatEverySecond, 1000);
      setTimeout(() => {
        clearInterval(intervalId);
        navigate('/book')
      }, 5000);

const redirect = ()=>{
    navigate('/book')
}

    return(
        <>
        <div className="not-found-container">
            <img src={FourZeroFourIcon} alt="*"/>
            <strong style={{fontSize:'18px',marginTop:'10px'}}>We couldn't find that page — let's get you back on track.</strong>
                  <button className="page-action-btn" onClick={redirect}>Back to Booking Page</button>
                  <strong>Redirecting in {timeleft} seconds</strong>
        </div>
        </>
    )
}

export default NotFoundPage;